import { useObjectFlagValue } from "@openfeature/react-sdk";
import flags from "../features/featureFlags/flags";

function isValidHourMinute(hour, minute) {
  return (
    Number.isInteger(hour) &&
    Number.isInteger(minute) &&
    hour >= 0 &&
    hour <= 23 &&
    minute >= 0 &&
    minute <= 59
  );
}

function parseEndTime(endDate, endTime, endHour, endMinute) {
  if (!endDate) return null;

  // If endDate already includes a time component, trust it as-is.
  if (typeof endDate === "string" && endDate.includes("T")) {
    return new Date(endDate);
  }

  // Preferred shape: endTime as HH:mm
  if (typeof endTime === "string") {
    const match = endTime.match(/^(\d{1,2}):(\d{2})$/);
    if (match) {
      const hour = Number(match[1]);
      const minute = Number(match[2]);
      if (isValidHourMinute(hour, minute)) {
        return new Date(
          `${endDate}T${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}:59.999`,
        );
      }
    }
  }

  const hour = Number(endHour);
  const minute = Number(endMinute);
  if (isValidHourMinute(hour, minute)) {
    return new Date(
      `${endDate}T${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}:59.999`,
    );
  }

  // Legacy behavior: treat endDate as end of day.
  return new Date(endDate + "T23:59:59.999");
}

export function usePromotion(subscriptionId) {
  const promo = useObjectFlagValue(flags.ADPHA_B2C_PROMOTION, null);
  if (!promo) return null;

  const { products, startDate, endDate, endTime, endHour, endMinute } = promo;
  const now = new Date();
  const inProducts = products?.includes(String(subscriptionId));
  const parsedStart = startDate ? new Date(startDate + "T00:00:00.000") : null;
  const parsedEnd = parseEndTime(endDate, endTime, endHour, endMinute);
  const afterStart = !parsedStart || now >= parsedStart;
  const beforeEnd = !parsedEnd || now <= parsedEnd;

  if (!inProducts || !afterStart || !beforeEnd) return null;
  return promo;
}
